<template lang="pug">
	.web-service--used-parameter-selector(v-if="items && items.length")
		.web-service-param-button.flex-row.space.align-center.justify(@click="showDropDown", :id="`menu_${id}`", :class="{ associated: associatedTemplateField }")
			fas(icon="link", size="xs")
		ContextMenu(:target="`#menu_${id}`", cssClass="used-services-context-menu", :items="menuItems", ref="menu", @item-click="onItemClick")
			template(v-slot:service="{ data }")
				.service.navigation-item(:style="{ '--imageUrl': `url('${data.imageUrl}')` }", :title="data.text")
					.item.flex-row.align-center.center.justify.space-medium
						.flex-row.flex-1.space.align-center
							.image-holder
								.image
							.fixed-width.wrap {{data.text}}
						fas(icon="angle-right", size="xs")
			template(v-slot:output="{ data }")
				.output(:title="data.text")
					.flex-row.justify.align-center.space.align-center(:class="{ associated: associatedTemplateField && associatedTemplateField === (data.param && data.param.templateField && data.param.templateField.id) }")
						fas(:icon="data.icon || (data.__type === 'output' ? 'o' : (data.__type === 'param' ? 'p' : 'c'))", size="xs")
						.flex-1
							.fixed-width.wrap {{data.text}}
			template(v-slot:header="{ data }")
				.output
					.font-small.upper.grey {{data.text}}
</template>

<script>		
	import ContextMenu from 'app-core/ContextMenu.vue';

	export default {
		translationCategory: 'webServiceCaller.StructureBuilder',
		name: 'web-service--used-parameter-selector',
		components: { ContextMenu },
		model: {
		},
		props: ['param', 'items', 'associations'],
		data() {
			return {
				id: this.$Data.uuid()
			};
		},		
		computed: {
			menuItems() {
				return this.items.map(f => ({
					template: 'service',
					service: f.service,
					imageUrl: f.service.ImageUrl,
					text: f.service.Name,
					items: f.params.map(p => ({
						...p,
						service: f.service,
						param: p,
						template: 'output',
						__type: p.__type,
						text: p.Caption || p.Name,
						icon: p.icon,
						action: p.action
					}))
				}))
			},
			associatedTemplateField() {
				return this.associations && this.associations[this.param?.Name];
			}
		},
		watch: {
		},
		mounted() {
		},		
		destroyed() {
		},
		methods: {
			showDropDown() {
				if (__DEBUG__ && this.items?.length)
					window.usedParameterSelector = this;
				if (this.$refs.menu)
					this.$refs.menu.show();
			},
			onItemClick(e) {
				const item = e?.itemData;
				if (item?.action) {
					this.$emit('action', item.action, this.param, item);
					return;
				}
				if (item?.param?.templateField?.id) {
					this.$emit('select', item?.param?.templateField?.id === this.associatedTemplateField ? null : item);
				} else {
					this.$emit('select', item);
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.web-service--used-parameter-selector {
		.associated {
			background: $base-accent;
			color: $base-bg;
		}
	}

	.used-services-context-menu {
		.output {
			.associated {
				color: $base-accent;
				font-weight: 400;
			}
		}
	}
</style>
